exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-button[data-v-45defd51]{display:inline-block;background:transparent;cursor:pointer;color:#1f1f1f;margin:0 0.32rem 0 0}.mm-button .asset-img[data-v-45defd51]{height:0.19rem;position:relative;top:0.01rem}.mm-logo[data-v-45defd51]{height:0.26rem;margin-right:0.16rem;position:relative;top:0.03rem}.mm-text[data-v-45defd51]{position:relative;top:0.02rem}\n", ""]);

// exports
